<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Api Payment"
              bc1="App"
              bc2="Api Payment"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card" v-if="showAllFilters">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-6 user_plan">
              <SelectOptions
                  label=""
                  selectAppend="currency"
                  labelValue="code"
                  :filter="{ flag: 'active' }"
                  :modelValue.sync="selectedAccount"
                  :url="showSelectAccountOption"
              />
            </div>
            <div class="col-md-6 user_status">
              <input class="form-control mt-sm-50" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
            </div>

          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-6 mb-1 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div >
                    <label>Select Store</label>
                    <SearchSelect
                        v-model="selectedStore"
                        url="v1/get-store"
                        :filterParams="{ status: 1 }"
                        :customLabelFn="customStoreNameForMultiselect"
                        placeholder="Search Store..."
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-1 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group">
                    <label>Select Terminal</label>
                    <multiselect
                        v-model="selectedTerminal"
                        :options="terminalData"
                        label="label"
                        track-by="id"
                        placeholder="Select Terminal"
                        :loading="terminalLoader"
                        variant="primary"
                        :custom-label="customStoreNameForMultiselect"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group">
                    <label>Select Channel</label>
                    <multiselect
                        v-model="selectedChannel"
                        :options="channelData"
                        label="label"
                        track-by="id"
                        placeholder="Select Channel"
                        :loading="channelLoader"
                        variant="primary"
                        :custom-label="customStoreNameForMultiselect"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_status">
              <date-picker
                v-model="fromDate"
                :disabledDate="disableFutureDates"
                valueType="format"
                :lang="lang"
                name="fromDate"
                placeholder="choose start date"
              ></date-picker>
            </div>
            <div class="col-md-4 user_status">
              <date-picker
                v-model="toDate"
                :disabledDate="disableFutureDates"
                valueType="format"
                :lang="lang"
                name="toDate"
                placeholder="choose end date"
              ></date-picker>
            </div>
            <div class="col-md-4 user_status">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
            </div>

          </div>
        </div>
        <div class="card">
          <div class="">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :filteredData="filteredData"
              :hidePdfExportButton="true"
              :show-per-page="true"
              @getFullResponse="getFullResponse"

          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import SearchSelect from "@/components/common/SearchSelect.vue";
export default {
  components:{
    SearchSelect,
    DatePicker
  },
  mounted() {
    this.showSelectAccountOption = 'v1/get-currency'
    this.showSelectTypesOption = 'v1/transaction-types'
    localStorage.setItem("url", "v1/get-payment-link");
    this.checkDataInStore('v1/get-payment-link')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.startCountdown();
  
  },
  data() {
    return {
      exportData: {
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'payment_links',
            payment_type: 2,
          }

          if(this.selectedStore){
            requestData.storeId = this.selectedStore.id
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }

          if(this.selectedType){
            requestData.transactionTypeId = this.selectedType.id
          }
          if(this.selectedAccount){
            requestData.currencyId = this.selectedAccount.id
          }
          if(this.search != ''){
            requestData.transactionId = this.search
          }
          if(this.toDate){
            requestData.toDate = this.toDate
          }
          if(this.fromDate){
            requestData.fromDate = this.fromDate
          }


          this.downloadReport(requestData)
        }
      },
      url: "v1/get-payment-link",
      storageKey: "apiPayments",
      showRefundModal: false,
      transactionId: '',
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'token',
          html: true,
          alter: (value,row) => {
            var html = ''
            if(row.transactions.length > 0){
              if(row.transactions[0].application == 'DIRECT_API_PAYMENT'){
                html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div class=""><span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span></div>
                        <div class="badge badge-light-info mt-1">Direct Api Payment</div>
                    </div>
                </div>
                `

              }else{
                html = `<span class="text-primary" style="cursor: pointer" title="Click For Details" >${value}</span>`
              }
            }else{
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details" >${value}</span>`
            }



            return html


          },
          cta: (row) => {
            this.copyText(row.token);
            this.$router.push({name: 'transactions-detail',params: {id:row.token}})
          }
        },
        {
          title: 'Status',
          valueKey: 'exipres_in',
          html: true,
          alter:  (value, obj) => {
            var givenDate = new Date(obj.created_at);
            var givenSeconds = givenDate.getTime() / 1000;
            var currentDate = new Date();
            var currentSeconds = currentDate.getTime() / 1000;
            var html = ''
            if(!obj.exipres_in){
              html = `<div class="badge badge-light-dark" style="margin-top: 0.5rem">Lifetime</div>`
            }
            // means expired
            else if ((obj.exipres_in < (currentSeconds-givenSeconds))) {
              html = `

                <div class="badge badge-light-danger " style="margin-top: 0.5rem">Expired</div>`

            }else{
              // let expiry = parseFloat(obj.exipres_in-(currentSeconds-givenSeconds)).toString()
              html = `<span class="countdown-timer" data-expires="${obj.exipres_in}" data-created="${obj.created_at}"></span>`
              // html = `<div class="badge badge-light-warning ml-1" style="margin-top: 0.5rem">${expiry.split('.')[0]} seconds left</div>\``
            }

            let statusHtml = ''
            if (obj.status == 1)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-success mb-sm-25 font-small-1">${obj.status_str}</div>`
            else if (obj.status == 2)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-danger mb-sm-25 font-small-1">${obj.status_str}</div>`
            else
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-warning mb-sm-25 font-small-1">${obj.status_str}</div>`


            html = `
                <div class="row justify-content-center">
                    <div class="mx-1">
                    ${statusHtml}
                    <br>
                    </div>
                ${html}
                </div>`


            return html


          },
        },
        {
          title: 'Customer',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value && value.length > 0){
              if(value[0]?.customer){
                html = ` <a href="javascript:void()" class="text-dark">${value[0].customer.name}</a>`
              }
            }

            return html


          }
        },
        {
          title: 'Customer Email',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value && value.length > 0){
              if(value[0]?.customer){
                html = ` <a href="javascript:void()" class="text-dark">${value[0].customer.email}</a>`
              }
            }

            return html


          }
        },
        {
          title: 'Sender Account Title',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value && value.length > 0)
              html = ` <a href="javascript:void()" class="badge badge-light-dark">${value[0].sender_account_title}</a>`

            return html


          }
        },
        {
          title: 'Sender Account Num',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${value[0].sender_account_number}</a>`

            return html


          }
        },
        {
          title: 'Receiver Account Title',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="badge badge-light-warning">${value[0].receiver_account_title}</a>`
            else{
              if(row.added_by_user && Object.keys(row.added_by_user).length > 0)
              html = ` <a href="javascript:void()" class="badge badge-light-warning">${(row.added_by_user.first_name).toUpperCase()+' '+(row.added_by_user.last_name).toUpperCase()}</a>`
            }

            return html


          }
        },
        {
          title: 'Schemas',
          valueKey: 'schemas',
          html: true,
          alter:  (value, obj) => {
            var html = ''
            if (value) {
              html = `<div class="grid">`
              if (obj.schemas.length) {
                obj.schemas.forEach((item) => {

                  html += `<div class="row"><div class="badge badge-light-primary mt-sm-1">${item.name}</div></div>`
                })
              }

              html += ` </div>`
            }


            return html
          }
        },
        {
          // title: 'Total Amount',
          title: 'Amount',
          // valueKey: 'total_amount',
          valueKey: 'amount',
          html: true,
          alter:  (value,row) => {
            var html = ''
            if (value)
              html = `<span  class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value)/100).toFixed(this.amountDecimalPlaces))}</span>&nbsp;<div class="badge badge-light-success">${row.currency.code}</div>`


            return html


          }
        },
        {
          title: 'Vat',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${parseFloat(value[0].vat / 100).toFixed(this.feesDecimalPlaces)}</a>`

            return html


          }
        },
        {
          title: 'Fees',
          valueKey: 'transactions',
          html: true,
          alter: (value,row) => {
            var html = 'N/A'
            if(value.length > 0)
              html = ` <a href="javascript:void()" class="text-dark">${parseFloat(value[0].fee / 100).toFixed(this.feesDecimalPlaces)}</a>`

            return html


          }
        },
        // {
        //   title: 'Payable Amount',
        //   valueKey: 'amount',
        //   html: true,
        //   alter:  (value,row) => {
        //     var html = ''
        //     if (value)
        //       html = `<span  class=" font-weight-bolder text-dark">${parseFloat((value-row.vat-row.fee)/100).toFixed(this.amountDecimalPlaces)}</span>&nbsp;<div class="badge badge-light-success">${row.currency.code}</div>`
        //
        //
        //     return html
        //
        //
        //   }
        // },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [

      ],
      deleteActions: [

      ],
      mutedData: [],
      externalTotalRecord: "",
      search: '',
      fromDate: null,
      toDate: null,
      selectedAccount: null,
      selectedType: null,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      filteredData: {paymentType:0},
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      showAllFilters:false,
    }
  },
  methods: {
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        document.querySelectorAll('.countdown-timer').forEach((element) => {
          let expiresIn = parseInt(element.getAttribute('data-expires'));
          let createdAt = new Date(element.getAttribute('data-created')).getTime();
          let currentTime = new Date().getTime();
          let elapsedSeconds = Math.floor((currentTime - createdAt) / 1000);
          let remainingSeconds = expiresIn - elapsedSeconds;

          // Find the closest row and the dynamic status element
          let row = element.closest('tr');
          let statusElement = row ? row.querySelector('.dynamic-status') : null;

          if (remainingSeconds <= 0) {
            // Clear the status if it exists
            if (statusElement) {
              statusElement.innerHTML = "";
            }
            element.innerHTML = `<span class="badge badge-light-danger ml-1" style="margin-top: 0.5rem">Expired</span>`;
          } else {
            element.innerHTML = `<small style="margin-top: 0.5rem" class=" font-weight-bolder row  text-danger justify-content-center">Expires In</small><span class="badge badge-light-warning" style="margin-top: 0.5rem">${this.formatTime(remainingSeconds)}</span>`;
          }
        });
      }, 1000);

    },

    formatTime(seconds) {
      let days = Math.floor(seconds / (3600 * 24));
      let hours = Math.floor((seconds % (3600 * 24)) / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      let sec = seconds % 60;

      return `${days}d ${hours}h ${minutes}m ${sec}s`;
    },
    getFullResponse(){
      this.showAllFilters=true
    },
    onSubmitFilters() {

      let filterData = {paymentType:0}

      if(this.selectedStore){
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel.id
      }

      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      if(this.selectedAccount){
        filterData.currencyId = this.selectedAccount.id
      }
      if(this.search != ''){
        filterData.transactionId = this.search
      }
      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }



      this.filteredData = filterData




    },
    clear(){
      this.selectedType = null
      this.selectedAccount = null
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {paymentType:0}

    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
  },
  watch: {
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
}
</script>

